import React, {useState} from 'react';
import Typical from 'react-typical';
import axios from 'axios'
import {toast} from 'react-toastify'

import imgBack from '../../../src/images/mailz.jpeg';
import load1 from '../../../src/images/load2.gif';
import ScreenHeading from '../../utilities/ScreenHeading/ScreenHeading';
import ScrollService from '../../utilities/ScrollService';
import Animations from '../../utilities/Animations';
import "./ContactMe.css";

export default function Contactme(props) {
    let fadeInScreenHandler = (screen) => {
        if (!props || screen.fadeInScreen !== props.id) return;
        Animations.animations.fadeInScreen(props.id);
      };
      
      ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);
      
      
    
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [banner, setBanner] = useState("");
    const [bool, setBool] = useState(false);

    const handleName = (e) => {
        setName(e.target.value);
    };
    const handleEmail = (e) => {
        setEmail(e.target.value);
    };
    const handleMessage = (e) => {
        setMessage(e.target.value);
    };
    const submitForm = async (e) =>{
        e.preventDefault();
        try {
            let data = {
                name,
                email,
                message,
            };
            setBool(true)
            if (name.length === 0 || email.length === 0 || message.length === 0) {
                setBanner("All fields are required");
                toast.error("All fields are required");
                setBool (false);
                return;
            }
            const res = await axios.post('/contact', data)
             if(res.status === 200){
                setBanner(res.data.msg)
                toast.success(res.data.msg)
                setBool (false);

                setName("");
                setEmail("");
                setMessage("");
            }
        } catch (error) {
    setBool(false);

    if (error.response) {
        toast.error(error.response.data?.msg || "Server error");
    } else if (error.request) {
        toast.error("No response from server");
    } else {
        toast.error(error.message);
    }
}
    };

    return (
        <div className='main-container fade-in' id={props.id || ""}>
            <ScreenHeading subHeading={"Lets keep in Touch"} title={"Contact Me"}/>
            <div className='central-form'>
                <div className='col'>
                <h2 className='title'>
                    <Typical
                        loop={Infinity}
                        steps={[
                        "Have a discussion.. ",
                        2000,
                        "Share experience ",
                        2000,
                        "Share knowledge.. ",
                        2000,                                               
                        ]}
                    />
                </h2>
                </div>
                <div className='back-form'>
                    <div className='img-back'>
                        <h4>
                            Please, Send Your Message Here!
                            <p></p>
                            <img src={imgBack} alt='imageSRC is missing'/>
                        </h4>
                    </div>
                    <form onSubmit={submitForm}>
                        <p>{banner}</p>
                        <label htmlFor='name'>Name</label>
                        <input type='text'
                        onChange={handleName}
                        value={name}
                        />

                        <label htmlFor='email'>Email</label>
                        <input type='email'
                        onChange={handleEmail}
                        value={email}                        
                        />

                        <label htmlFor='message'>Message</label>
                        <textarea type='text'
                        onChange={handleMessage}
                        value={message}
                        />          

                        <div className='send-btn'>
                            <button type='submit'>
                                send
                                <i className='fa fa-paper-plane'/>
                                {bool?(<b className='load'>
                                    <img src={load1} alt='imageSRC not responding'/>
                                </b>):("")}
                           
                            </button>
                        </div>              
                    </form>
                </div>
            </div>
        </div>
    );
}

